module.exports = __webpack_public_path__ + "static/img/LogoLTCVersionPaises.4301b04.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/LogoLTCVersionPaises.svg
// module id = KYhX
// module chunks = 62